import { Box, Image, Spinner, Step, StepIndicator, StepSeparator, StepStatus, Stepper } from "@chakra-ui/react"
import TransferLabelDropDown from "./TransferLabelDropDown"
import { TransferMicroStatusWorkflow, TransferStatusWorkflow, keyType } from "../types";
import { transferStepStatus, transferTips } from "@/utils/constants";
import { getIsFetchingTransferStatusWorkflow } from "../ducks/selectors";

interface TransferStatusStepper {
    transferStatusWorkflow: TransferStatusWorkflow[]
    version:number
}

const TransferStatusStepper = ({transferStatusWorkflow, version}: TransferStatusStepper) => {
    const isFetchingTransferStatusWorkflow = getIsFetchingTransferStatusWorkflow();
    let suggestion = null;
    const getStepperIndex = () => {
        let index = 0;
        let microStatusForSuggestion: Array<TransferMicroStatusWorkflow> = [];
        if (!transferStatusWorkflow || transferStatusWorkflow.length <= 0)
          return index;
        transferStatusWorkflow.map((step) => {
          const { stepStatus, order, microStatus } = step;
          if (
            stepStatus === transferStepStatus.success ||
            stepStatus === transferStepStatus.in_progress ||
            stepStatus === transferStepStatus.failed
          )
            if (order > index) {
              index = order > index ? order : index;
              microStatusForSuggestion = microStatus;
            }
        });
        if (microStatusForSuggestion && microStatusForSuggestion.length > 0)
          microStatusForSuggestion.forEach((microStep) => {
            if (transferTips[microStep.status as keyType<typeof transferTips>]) {
              suggestion =
                transferTips[microStep.status as keyType<typeof transferTips>];
            }
          });
        return index - 1;
    };
  const currentStep = getStepperIndex();

return (
    <div className="transfer-status-row">
      {/* <span className="transfer-details-label"> Status:</span> */}
      <Stepper index={currentStep} className="stepper-wrapper">
        {isFetchingTransferStatusWorkflow &&
          transferStatusWorkflow.length === 0 && (
            <Spinner className="stepper-loader" />
          )}
        {transferStatusWorkflow.map((step, index) => (
          <Box className="license-stepper__step-wrapper certificate-upload-steps">
            <Step key={index} className="license-stepper__step">
              <StepIndicator className="license-stepper__step-indicator">
                <StepStatus
                  complete={
                    <div className="stepper__step-complete">
                      <div
                        className={`stepper__step-complete-inner ${
                          step.stepStatus === transferStepStatus.failed
                            ? 'stepper__step-failed'
                            : ''
                        }`}
                      >
                        {step.stepStatus ===
                        transferStepStatus.failed ? (
                          <>!</>
                        ) : (
                          <Image
                            width={13.06}
                            height={10.39}
                            src="/images/ui/checked-round-border.svg"
                            alt="check icon"
                          />
                        )}
                      </div>
                    </div>
                  }
                  incomplete={
                    <div className="stepper__step-incomplete">
                      <div className="stepper__step-incomplete-inner">
                        <span>{step.order}</span>
                      </div>
                    </div>
                  }
                  active={
                    <div className="stepper__step-active">
                      <div
                        className={`stepper__step-active-inner ${
                          step.stepStatus === transferStepStatus.failed
                            ? 'stepper__step-failed'
                            : ''
                        }`}
                      >
                        {step.stepStatus ===
                        transferStepStatus.failed ? (
                          <>!</>
                        ) : (
                          <Image
                            width={13.06}
                            height={10.39}
                            src="/images/ui/checked-round-border.svg"
                            alt="check icon"
                          />
                        )}
                      </div>
                    </div>
                  }
                />
                <TransferLabelDropDown step={step} version={version} />
              </StepIndicator>
              <StepSeparator
                className={`stepper__step-indicator ${
                  currentStep < index + 1
                    ? 'stepper__step-indicator-light'
                    : 'stepper__step-indicator-dark'
                }`}
              />
            </Step>
          </Box>
        ))}
      </Stepper>
    </div>
)
}

export default TransferStatusStepper
